import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatTimeAgo(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();

  // Convert both dates to timestamps for comparison
  const timestamp = date.getTime();
  const currentTimestamp = now.getTime();

  // If the date is more than a day in the future, assume it's a timezone/clock issue
  // and treat it as if it just happened
  if (timestamp > currentTimestamp + (24 * 60 * 60 * 1000)) {
    return 'just now';
  }

  const seconds = Math.floor((currentTimestamp - timestamp) / 1000);
  
  // If the time difference is negative (near future date), return "just now"
  if (seconds < 0) {
    return 'just now';
  }

  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (years > 0) {
    return years === 1 ? '1 year ago' : `${years} years ago`;
  } else if (months > 0) {
    return months === 1 ? '1 month ago' : `${months} months ago`;
  } else if (days > 0) {
    return days === 1 ? '1 day ago' : `${days} days ago`;
  } else if (hours > 0) {
    return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
  } else if (minutes > 0) {
    return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
  } else {
    return seconds <= 30 ? 'just now' : `${seconds} seconds ago`;
  }
}
